(function ($, Drupal, settings) {
	"use strict"
	$(document).ready(function(){
		$(window).scroll(function(){
			let scroll = $(window).scrollTop()
			$('header').toggleClass('active', scroll > 150)
			$('.back-top').toggleClass('active', scroll > 450)
			if ($(window).width() < 760) {
				$('header').toggleClass('active', scroll > 50)
			}
		})
		$('.header-hamburger').click(function(){
			$(this).toggleClass('active')
			$('.header-menu, html, body').toggleClass('active')
			$('header').toggleClass('menu-open')
		})
		$('body').on('click', '.header-menu-drop, .header-menu-close', function(){
			$('html, body, .modal, .header-menu, .header-hamburger').removeClass('active')
			$('header').removeClass('menu-open')
		})

		$('body').on('mouseup', function(e){
			let modal = $('.modal-content')
			if (modal.length > 0) {
				if (!modal.is(e.target) && modal.has(e.target).length === 0) {
					modal.parent().removeClass('active')
					if (modal.find('video').length > 0) {
						modal.find('video').get(0).pause()
					}
				}
			}
		})

		$('body').on('click', '.header-menu .show-sub-menu', function(e){
			e.preventDefault()
			$(this).parents('.has-child').toggleClass('active')
		})

		$('.slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 5000
		})

		if ($('.cards-items-slider').length > 0) {
			$('.cards-items-slider').each(function(){
				$(this).slick({
					infinite: false,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					responsive: [
						{
							breakpoint: 1000,
							settings: {
								slidesToShow: 3
							}
						},
						{
							breakpoint: 760,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 500,
							settings: {
								slidesToShow: 1,
								adaptiveHeight: true
							}
						}
					]
				})
			})
		}

		$('body').on('click', '.video-preview', function(){
			$(this).siblings('.modal').addClass('active')
		})

		$('body').on('click', '.modal .btn-hover, .modal .close', function(e){
			$('.modal').removeClass('active')
			let video = $(this).parents('.modal').find('video')
			if (video.length > 0) {
				video.get(0).pause()
			}
		})
		$('a[href*="#"]:not(.scroll-false)').on('click', function() {
			let href = '#' + $(this).attr('href').split('#')[1]
			$('html, body').animate({
				scrollTop: $(href).offset().top - 150
			})
			return false
		})
		let target = window.location.hash
		if (target != ''){
			let $target = $(target);
			$('html, body').stop().animate({
				'scrollTop': $target.offset().top - 150
			})
		}

		setSliderDotPosition()

		const docsItems = document.querySelectorAll('.docs-item')
		docsItems.forEach(item => {
			let isDown = false
			let startX
			let scrollLeft

			item.addEventListener('mousedown', (e) => {
				isDown = true
				item.classList.add('active')
				startX = e.pageX - item.offsetLeft
				scrollLeft = item.scrollLeft
			});
			item.addEventListener('mouseleave', () => {
				isDown = false
				item.classList.remove('active')
			});
			item.addEventListener('mouseup', () => {
				isDown = false
				item.classList.remove('active')
			});
			item.addEventListener('mousemove', (e) => {
				if(!isDown) return
				e.preventDefault()
				const x = e.pageX - item.offsetLeft
				const walk = (x - startX) * 1
				item.scrollLeft = scrollLeft - walk
			})
		})

		$('.docs-item').each(function(){
			let $this = $(this)
			if ($this.hasHorizontalScrollBar()) {
				$this.addClass('has-scroll')
			}
		})
		
		$('body').on('click', '.faq-item .question', function(){
			$(this).toggleClass('active')
			$(this).siblings('.answer').slideToggle()
		})

		$('.map').each(function(){
			let $this = $(this)
			setTimeout(function(){
				ymaps.ready(initMap($this))
			}, 1000)
		})

		$('a:not([href^="tel:"]):not([href^="mailto:"])').click(function(e){
			let href = $(this)[0]['href'],
					url = window.location.host
			if (!href.includes(url)) {
				e.preventDefault()
				window.open(href, '_blank')
			}
		})

		$('body').on('click', '.show-pass', function(){
			let passInput = $(this).siblings('.form-item').find('input[name="pass"]')
			if (passInput.attr('type') == 'password') {
				passInput.attr('type', 'text')
			} else {
				passInput.attr('type', 'password')
			}
		})

		if ($('label[for="edit-pass-pass1"]').length > 0) {
			let text = $('label[for="edit-pass-pass1"]').text()
			$('input[id="edit-pass-pass1"]').attr('placeholder', text)
		}

		if ($('label[for="edit-pass-pass2"]').length > 0) {
			let text = $('label[for="edit-pass-pass2"]').text()
			$('input[id="edit-pass-pass2"]').attr('placeholder', text)
		}

		$('.form-item-field-policy-value label').each(function(){
			let text = $(this).text(),
					policyLink = $(this).parents('.form-block-actions').siblings('.policy-link').text()
			let policyText = '<a href="' + policyLink +'" target="_blank">' + text + '</a>'
			$(this).html(policyText)
		})

		$('.back-top').click(function() {
			$('html, body').animate({ scrollTop: 0 }, 'slow')
			return false
		})

		if ($(window).width() < 760) {
			$('.header-menu-main').append($('.header-lang, #block-vk, .header-personal'))
		}
		if ($(window).width() <= 760 && $('.gallery-items').length > 0) {
			$('.gallery-items').each(function(){
				$(this).slick({
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					adaptiveHeight: true
				})
			})
		}

		$(window).resize(function(){
			setSliderDotPosition()
			if ($(window).width() < 760) {
				$('.header-menu-main').append($('.header-lang, #block-vk, .header-personal'))
			} else if ($(window).width() > 760 & $('.header-bottom .container .header-lang').length == 0) {
				$('.header-lang, #block-vk, .header-personal').insertAfter($('.header-logo'))
			}
		})
	})

	$(document).ajaxComplete(function(){
		$('.form-item-field-policy-value label').each(function(){
			let text = $(this).text(),
					policyLink = $(this).parents('.form-block-actions').siblings('.policy-link').text()
			let policyText = '<a href="' + policyLink +'" target="_blank">' + text + '</a>'
			$(this).html(policyText)
		})
	})

	function setSliderDotPosition() {
		if ($('.slider.slick-initialized').length > 0) {
			let dots = $('.slider .slick-dots'),
						right = ($('.slider .container').outerWidth(true) - $('.slider .container').outerWidth() + 30) / 2
				dots.css('right', right)
		}
	}

	function initMap(mapItem) {
		let coords = mapItem.data('coords').split(', '),
				desc = mapItem.data('desc'),
				map = new ymaps.Map(mapItem[0], {
			center: [+coords[0], +coords[1]],
			zoom: 17,
		})

		let placemark = new ymaps.Placemark([+coords[0], +coords[1]],
		{
			balloonContent: desc
		},
		{
			iconLayout: "default#image",
			iconImageHref: "/web/themes/custom/odk/img/map.svg",
			iconImageSize: [28, 42]
		})

		map.controls.remove("geolocationControl")
		map.controls.remove("searchControl")
		map.controls.remove("trafficControl")
		map.controls.remove("typeSelector")
		map.controls.remove("fullscreenControl")
		map.controls.remove("rulerControl")
		map.behaviors.disable(["scrollZoom"])

		map.geoObjects.add(placemark)
	}

	$.fn.hasHorizontalScrollBar = function () {
		return this[0].clientWidth < this[0].scrollWidth;
	}
})(jQuery, Drupal, drupalSettings)
